import ButtonComponent from "../common/ButtonComponent";
import BannerComponent from "../common/BannerComponent";
import PlatformSolutonComponent from "../common/PlatformSolutionComponent";
import TrustLeaderComponent from "../common/TrustLeaderComponent";
import RoleCsrComponent from "../common/RoleCsrComponent";
import CustomerSupportComponent from "../common/CustomerSupportComponent";
import NewsComponent from "../common/NewsComponent";
import WorkWithTcsComponent from "../common/WorkWithTcsComponent";
import ExpressCenterComponent from "../common/ExpressCenterComponent";
import EcomSolutionComponent from "../common/EcomSolutionComponent";
import { useEffect } from "react";
import ProductSection from "../common/ProductSection";

const Mainpage = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList?.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList?.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false
  );
  return (
    <div>
      <BannerComponent></BannerComponent>
      <ButtonComponent></ButtonComponent>
      <PlatformSolutonComponent></PlatformSolutonComponent>
      <ProductSection></ProductSection>
      <ExpressCenterComponent></ExpressCenterComponent>
      <EcomSolutionComponent></EcomSolutionComponent>
      <TrustLeaderComponent></TrustLeaderComponent>
      <RoleCsrComponent></RoleCsrComponent>
      <CustomerSupportComponent></CustomerSupportComponent>
      <NewsComponent></NewsComponent>
      <WorkWithTcsComponent></WorkWithTcsComponent>
      {/* <FooterComponent></FooterComponent> */}
    </div>
  );
};

export default Mainpage;
